export default __webpack_public_path__ + "static/hq12-a9459092df7803b2a8ceaa99a5a06f61.jpg";